import { StateSchema } from 'app/config/storeConfig/types';
import { CreateWarehouseFormFields } from '../types';

export const getFormData = (state: StateSchema): Partial<CreateWarehouseFormFields> => state.createWarehouseModal.formData;
